/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client: authApi.
 * SCOPE: HTTP calls to backend.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * authApi - Frontend API client: authApi.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_registerInit */
/* START_CONTRACT: registerInit
 * PURPOSE: Инициировать регистрацию — отправить email для получения кода подтверждения.
 * INPUTS: { email: string }
 * OUTPUTS: { Promise<AxiosResponse> - POST /user/register/init }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-FE-API, M-REGISTRATION
 * END_CONTRACT: registerInit
 */
export function registerInit(email) {
  return apiClient.post('/user/register/init', { email });
}
/* END_METHOD_registerInit */

/* START_METHOD_registerValidate */
/* START_CONTRACT: registerValidate
 * PURPOSE: Проверить код подтверждения email на шаге регистрации.
 * INPUTS: { data: { email: string, code: string } }
 * OUTPUTS: { Promise<AxiosResponse> - POST /user/register/validate }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-FE-API, M-REGISTRATION
 * END_CONTRACT: registerValidate
 */
export function registerValidate(data) {
  return apiClient.post('/user/register/validate', data);
}
/* END_METHOD_registerValidate */

/* START_METHOD_registerConfirm */
/* START_CONTRACT: registerConfirm
 * PURPOSE: Завершить регистрацию — установить пароль и активировать учётную запись.
 * INPUTS: { data: { email: string, code: string, password: string } }
 * OUTPUTS: { Promise<AxiosResponse> - POST /user/register/confirm }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-FE-API, M-REGISTRATION
 * END_CONTRACT: registerConfirm
 */
export function registerConfirm(data) {
  return apiClient.post('/user/register/confirm', data);
}
/* END_METHOD_registerConfirm */

/* START_METHOD_login */
/* START_CONTRACT: login
 * PURPOSE: Аутентифицировать пользователя по email и паролю.
 * INPUTS: { email: string, password: string }
 * OUTPUTS: { Promise<AxiosResponse> - POST /api/auth/login с access/refresh токенами }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-FE-API, M-AUTH
 * END_CONTRACT: login
 */
export function login(email, password) {
  return apiClient.post('/api/auth/login', { email, password });
}
/* END_METHOD_login */

/* START_METHOD_refreshToken */
/* START_CONTRACT: refreshToken
 * PURPOSE: Обменять refresh token на новую пару токенов.
 * INPUTS: { token: string - refresh token }
 * OUTPUTS: { Promise<AxiosResponse> - POST /api/auth/refresh }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-FE-API, M-AUTH, M-REFRESH-TOKEN
 * END_CONTRACT: refreshToken
 */
export function refreshToken(token) {
  return apiClient.post('/api/auth/refresh', { refreshToken: token });
}
/* END_METHOD_refreshToken */
